/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class DepositSlipsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      depositSlips: this.store.findAll('finance/deposit-slip'),
    });
  }
}
